<script setup>
import { ref, computed } from 'vue';
import Input from 'dashboard/components-next/input/Input.vue';
import FormFooter from './FormFooter.vue';

const emit = defineEmits(['sendMessage', 'cancel']);

const latitude = ref('');
const longitude = ref('');
const name = ref('');
const address = ref('');

// Evolution's /send/location rejects the request server-side without an address
// ("address is required"), even though the coordinates alone are all WhatsApp needs
// to render a pin — so this form requires it too rather than let sends fail silently.
const isValid = computed(() => {
  const lat = Number(latitude.value);
  const lng = Number(longitude.value);
  return (
    latitude.value !== '' &&
    longitude.value !== '' &&
    !Number.isNaN(lat) &&
    !Number.isNaN(lng) &&
    !!address.value.trim()
  );
});

const submit = () => {
  if (!isValid.value) return;

  emit('sendMessage', {
    message: '',
    location: {
      latitude: Number(latitude.value),
      longitude: Number(longitude.value),
      name: name.value.trim() || undefined,
    },
    contentAttributes: { data: { address: address.value.trim() } },
  });
};
</script>

<template>
  <div class="flex flex-col gap-4">
    <Input
      v-model="latitude"
      type="number"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.LOCATION.LATITUDE')"
    />
    <Input
      v-model="longitude"
      type="number"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.LOCATION.LONGITUDE')"
    />
    <Input
      v-model="name"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.LOCATION.NAME')"
    />
    <Input
      v-model="address"
      :label="$t('CONVERSATION.EVOLUTION_INTERACTIVE.LOCATION.ADDRESS')"
    />
    <FormFooter
      :disabled="!isValid"
      @cancel="$emit('cancel')"
      @submit="submit"
    />
  </div>
</template>
